/* eslint-disable */
import {KnowledgebaseMenuItem} from './KnowledgebaseMenuItem';
import {BhImage} from './BhImage';
import {BasePageModel} from './BasePageModel';
/**
* @description Interface for Avensia.Commerce.Web.Models.Pages.KnowledgebasePageModel
*/
export interface KnowledgebasePageModel extends BasePageModel {
	shouldRedirect: boolean;
	menuItems: KnowledgebaseMenuItem[];
	functionLinks: KnowledgebaseMenuItem[];
	houseLinks: KnowledgebaseMenuItem[];
	relatedProductArticles: KnowledgebaseMenuItem[];
	relatedArticles: KnowledgebaseMenuItem[];
	stepByStepArticles: KnowledgebaseMenuItem[];
	header: string;
	shortBody: string;
	body: string;
	image: BhImage;
	children: KnowledgebaseMenuItem[];
	inArticle: string[];
	imageCaption: string;
	type: string;
	searchResult?: KnowledgebaseMenuItem[];
}
export const isKnowledgebasePage = (model: unknown): model is KnowledgebasePageModel => (model as KnowledgebasePageModel).componentName === 'KnowledgebasePage';
